export const Switch = ({ value, size = 40, onClick, loading }) => {
    return (
        <div className={`flex flex-row items-center rounded-full p-1 ${value ? "bg-brand-primary" : "bg-gray-200"} cursor-pointer`} style={{
            height: size,
            width: size * 2,
            justifyContent: value ? "flex-end" : "flex-start",
        }} onClick={() => loading ? null : onClick()}>
            <div className="flex h-full bg-white rounded-full justify-center items-center" style={{ aspectRatio: 1 }}>
                {loading && <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-brand-primary mr-1"></div>}
            </div>
        </div>
    );
};